const $ = jQuery.noConflict();
import FormLabel from './formLabel';

'use strict';
const FormHelpers = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domBody: $('body'),
	$domButtonForLoader: $('.login-block__bottom-btn, .register-block__btn, .lost-pass__btn'),
	strCF7Holder: '.js-cf7-holder',
	strForm: '.wpcf7-form',
	strTriggerURL: '#wpcf7-f17-o1',
	classSent: 'form-is-sent',
	classInvalid: 'invalid',

	/** @description Initialize */
	init: function() {
		this.checkIfIE();
		this.afterFormSubmit();
		this.bindEvents();
		this.showLoaderOnButtonClick();
		this.showPassword();
		$('.file-input').attr('multiple', 'multiple');
		$('.file-input').attr('name', 'upload-file[]');
		this.showLoaderOnButtonClickAddresses();
		if($('#wc-cardknox-cc-form').length > 0 && $('.woocommerce-order-pay').length > 0) {
			/* eslint-disable */
			let style = {
				outline: 'none',
				width: '50%',
				background: 'white',
				'font-size': '16px',
				display: 'flex',
				'align-items': 'center',
				padding: '0 22px',
				height: '60px',
				'max-width': '100%',
				border: '2px solid #cfcfcf',
				'font-family': 'degular, Georgia, serif'
			};
			setIfieldStyle('card-number', style);
			setIfieldStyle('cvv', style);
			/* eslint-enable */
			window.addEventListener('load', function() {
				$('.woocommerce-order-pay #wc-cardknox-cc-form').css('opacity', '1');
			});
		}

		const loginCheckoutWrap = $('.js-checkout-login-wrap');
		if (loginCheckoutWrap.length > 0) {
			loginCheckoutWrap.insertAfter($('.section-title.checkout-form__title'));
			loginCheckoutWrap.css('display', 'block');
			setTimeout(() => {
				loginCheckoutWrap.css('position', 'relative');
				$('.checkout-form__left-wrap').css('margin-top', '38px');
			}, 100);
		}
		$('.default').on('click', function() {
			$('.default').addClass('is-active');
		});
		$('<label>Country/Region <span>*</span></label>').prependTo($('.checkout-form__left-wrap #billing_country_field'));
		$('<label>State/County</label>').prependTo($('.checkout-form__left-wrap #billing_state_field'));
		$('<label>Country/Region <span>*</span></label>').prependTo($('.woocommerce-shipping-fields__field-wrapper #shipping_country_field'));
		$('<label>State/County</label>').prependTo($('.woocommerce-shipping-fields__field-wrapper #shipping_state_field'));
		// Check sessionStorage for existing country values before setting defaults
		const checkoutFormData = sessionStorage.getItem('checkout_form_data');
		let billingCountrySet = false;
		let shippingCountrySet = false;

		try {
			if (checkoutFormData) {
				const data = JSON.parse(checkoutFormData);
				billingCountrySet = !!data.billing_country;
				shippingCountrySet = !!data.shipping_country;
			}
		} catch (e) {
			// If parsing fails, treat as not set
			billingCountrySet = false;
			shippingCountrySet = false;
		}

		// Always set default if not set, even if sessionStorage is missing or invalid
		if (!billingCountrySet) {
			setTimeout(() => {
				$('#billing_country').val('US');
				$('#billing_country').trigger('change');
			}, 100);
		}

		$('.woocommerce-form__label-for-checkbox').on('click', function() {
			if (!shippingCountrySet) {
				setTimeout(() => {
					$('#shipping_country').val('US');
					$('#shipping_country').trigger('change');
					// $('#shipping_state_field label').removeClass('is-moved');
				}, 100);
			}
		});
		// $(document).ready(function() {
		// 	let urlParams = new URLSearchParams(window.location.search);
		// 	if (urlParams.get('popup') === 'open') {
		// 		$('.js-custom-order__popup').addClass('is-active');
		// 	}
		// });
	},

	/**
	 * @description CF7 after submit popup trigger. Structure-example ( https://www.dropbox.com/s/oyj5revbgwigzxr/download.jpg?dl=0 )
	 * @example Global.functions.afterFormSubmit('.js-cf7-holder', 'form-is-sent', 8000);
	 * @param {string} formHolder - form holder class (recommended/default is '.js-cf7-holder')
	 * @param {string} sentClass - class added to form parent to trigger popup (default is 'form-is-sent')
	 * @param {number} delay - delay time before sentClass is removed (default delay time is 5000ms)
	 */
	afterFormSubmit: (formHolder = '.js-cf7-holder', sentClass = 'form-is-sent') => {
		document.addEventListener('wpcf7mailsent', (e) => {
			const formId = e.detail.id;

			FormHelpers.$domBody.addClass('prevent-scroller');
			$('.' + FormLabel.classMoved).removeClass(FormLabel.classMoved);
			$(formId).parents(formHolder).addClass(sentClass);
			$('.cf7-holder__popup').addClass('is-active');
			$('.wpcf7-form .select2-selection__rendered').empty();
			$('.js-custom-order__popup').removeClass('is-active');
			// $('.custom-form__input-d-and-d-subtitle').fadeIn();
			// $('.custom-form__input-d-and-d-title').text('Upload photos of the puzzle');
			// $('.custom-form__input-d-and-d-delete').fadeOut();

			setTimeout(() => {
				$(formHolder).removeClass(sentClass);
			});
		}, false);
	},

	bindEvents: () => {
		$('form.wpcf7-form').on('submit', function() {
			const form = $(this);
			const button = form.find('input[type=submit]');
			const currentVal = button.val();
			// store the current value so we can reset it later
			button.attr('data-value', currentVal);
			// disable the button
			button.prop('disabled', true);

		});
		$('.wpcf7').on('wpcf7invalid', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
		$('.wpcf7').on('wpcf7mailsent', function() {
			$('form.wpcf7-form').find('input[type=submit]').prop('disabled', false);
		});
	},
	// If user use Internet Explorer this is custom trigger for Thank you msg for CF7
	checkIfIE() {
		const url = window.location.href;
		if (url.indexOf(FormHelpers.strTriggerURL) > -1 && !$(FormHelpers.strForm).hasClass(FormHelpers.classInvalid)) {
			$(FormHelpers.strForm).parents(FormHelpers.strCF7Holder).addClass(FormHelpers.classSent);

			setTimeout(() => {
				$(FormHelpers.strCF7Holder).removeClass(FormHelpers.classSent);
			}, 5000);
		}
	},

	showLoaderOnButtonClick: function() {
		FormHelpers.$domButtonForLoader.on('click', function() {
			$('.form-loader').addClass('is-active');
		});
	},

	showLoaderOnButtonClickAddresses: function() {
		$('.woocommerce-address-fields-btn').on('click', function() {
			$('.woocommerce-address-fields-btn').addClass('is-active');
		});
	},

	showPassword: function() {
		setTimeout(function() {
			$('.form-pass-icon').on('click', function() {
				const input = $(this).parent().find('input');
				if (input[0].type === 'password') {
					input[0].type = 'text';
					$(this).addClass('is-active');
				} else {
					input[0].type = 'password';
					$(this).removeClass('is-active');
				}
			});
		}, 200);
	},
};

export default FormHelpers;
